import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
const NODE_CHANNEL = process.env.NODE_CHANNEL

// 解决路由访问重复时报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.place;
Router.prototype.place = function place(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

export const constantRouterMap = [
  // {
  //   path: '/item_manage',
  //   redirect: '/item_manage',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/item_manage',
  //       component: () => import('@/views/itemmanage/index'),
  //       name: 'item_manage',
  //       meta: {
  //         title: '项目管理',
  //         icon: 'mechanical'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/data_notes',
    component: Layout,
    redirect: '/data_notes',
    meta: {
      title: '数据验收',
      icon: 'model'
    },
    children: [
      {
        path: '/data_notes',
        component: () => import('@/views/data_notes/index'),
        meta: {
          title: '数据采集',
          icon: 'dataset'
        },
        hidden: true,
        children: [
          {
            path: 'program_table',
            name: 'program_table',
            component: () => import('@/views/data_notes/views/ProgramTable.vue'),
            hidden: true,
            meta: {
              keepAlive: true
            }
          },
          {
            path: 'folder_table/:pid',
            name: 'folder_table',
            component: () => import('@/views/data_notes/views/FolderTable.vue'),
            hidden: true,
          },
          {
            path: 'progress/:pid',
            name: 'progress',
            component: () => import('@/views/data_notes/views/Progress.vue'),
            hidden: true
          },
          {
            path: 'format_output_json/:pid/:id',
            name: 'format_output_json',
            component: () => import('@/views/data_notes/views/FormatOutputJson.vue'),
            hidden: true
          },
          {
            path: '',
            redirect: 'program_table',
            hidden: true
          }
        ]
      }
    ]
  },
  {
    path: '/data_settle',
    redirect: '/data_settle',
    component: Layout,
    hidden: NODE_CHANNEL !== 'longmao',
    children: [
      {
        path: '/data_settle',
        name: 'data_settle',
        component: () => import('@/views/data_settle/index.vue'),
        meta: {
          title: '数据结算',
          icon: 'datasettle'
        },
      },
      {
        path: '/project_settle/:vid',
        name: 'project_settle',
        component: () => import('@/views/data_settle/SettleFolder.vue'),
        hidden: true
      },
    ]
  },
  // {
  //   path: '/data_set',
  //   component: Layout,
  //   redirect: '/data_set',
  //   meta: {
  //     title: '数据采集',
  //     icon: 'dataset'
  //   },
  //   children: [{
  //       path: '/data_set',
  //       component: () => import('@/views/dataset/index'),
  //       meta: {
  //         title: '数据采集',
  //         icon: 'dataset'
  //       },
  //       hidden: true,
  //       children: [{
  //           path: 'dataset',
  //           name: 'DataSet',
  //           component: () => import('@/views/dataset/views/DataSet'),
  //           hidden: true
  //         },
  //         {
  //           path: 'batchs',
  //           name: 'DataSetBatchs',
  //           component: () => import('@/views/dataset/views/DataSetBatchs'),
  //           hidden: true
  //         },
  //         {
  //           path: 'file_table',
  //           name: 'DataSetFiles',
  //           component: () => import('@/views/dataset/views/DataSetFiles'),
  //           hidden: true
  //         },
  //         {
  //           path: '',
  //           redirect: 'dataset',
  //           hidden: true
  //         }

  //       ]
  //     },

  //   ]
  // },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/index'),
    hidden: true
  },
  //test
  {
    path: '/dialog',
    name: 'dialog',
    component: () => import('@/views/data_notes/components/FolderTablePart/openDialog.vue'),
    hidden: true
  },
]

export default new Router({
  mode: 'history',
  // mode: 'hash',
  routes: constantRouterMap
})

export const asyncRouterMap = [
  // {
  //   path: '/pdf',
  //   component: Layout,
  //   redirect: '/pdf/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: HelloWorld1,
  //       name: 'PDF',
  //       meta: { title: 'pdf', icon: 'pdf' }
  //     }
  //   ]
  // },
  // { path: '*', redirect: '/', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js